<template>
    <div>

        <div v-if="generatedShowMessage" class="alert alert-success">Dokumenty zostały wygenerowane</div>
        <div v-if="documentError" class="alert alert-danger" role="alert"><span
                class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ documentError }}
        </div>
        <alert-loading v-if="loading"></alert-loading>
        <b-row v-if="!isDocumentAlreadyGenerated && !loading">
            <b-col>
                <my-button text="Generuj dokumenty" icon="documents" :action="generateDocuments"/>
            </b-col>
        </b-row>
        <b-row v-if="isDocumentAlreadyGenerated && !loading">
            <b-col>
                <my-button text="Generuj ponownie" icon="documents" variant="primary" :action="generateDocuments"/>
            </b-col>
            <b-col>
                <my-button class="poll-right" text="Pobierz wszystko" icon="documents" variant="primary" :action="downloadAllFile"/>
            </b-col>
        </b-row>

        <div v-if="!loading" class="table-responsive">
            <table class="table table-striped table-bordered table-hover table-clickable table-search">
                <thead>
                <tr>
                    <th>Nazwa</th>
                    <th>Typ dokumentu</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in documentListItems" >
                    <td class="td-no_link">{{ item.name }}</td>
                    <td class="td-no_link">{{ item.type | translate }}</td>
                    <td>
                        <a href="#" class="btn btn-icon" v-b-tooltip.hover.bottom title="Pobierz" @click.prevent="downloadFile(item.id)">
                            <svg-icon name="download"/>
                        </a>
                        <a href="#" class="btn btn-icon" v-b-tooltip.hover.bottom title="Podgląd" @click.prevent="previewFile(item.id)">
                            <svg-icon name="preview"/>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import http from './../../utils/http'

  export default {
    mounted () {
      this.getDocumentsList(this.retrieved.id);
    },
    data: function () {
      return {
        item: {},
        errors: {},
        generatedShowMessage: false
      }
    },
    methods: {
      downloadAllFile(){
        http.download('/download/agreement/all-document/' + this.retrieved.id + '?');
      },
      downloadFile(documentId){
        http.download('/download/agreement/document/' + documentId + '?');
      },
      previewFile(documentId){
        http.preview('/download/preview/agreement/document/' + documentId + '?');
      },
      generateDocuments () {
        this.generate(this.retrieved.id)
      },
      ...mapActions({
        generate: 'agreement/document/generate',
        getDocumentsList: 'agreement/documentList/getItems'
      })
    },
    computed: {
      loading () {
        return this.retrieveLoading || this.documentLoading || this.documentListLoading
      },
      isDocumentAlreadyGenerated () {
        if (this.retrieved && this.retrieved.step.indexOf('additional') > -1) {
          return true
        }
        return false
      },
      ...mapGetters({
        retrieveLoading: 'agreement/update/retrieveLoading',
        documentLoading: 'agreement/document/loading',
        documentListLoading: 'agreement/documentList/loading',
        documentListItems: 'agreement/documentList/items',
        documentError: 'agreement/document/error',
        documentGenerated: 'agreement/document/generated',
        retrieved: 'agreement/update/retrieved',
      })
    },
    watch: {
      'documentGenerated': function (data) {
        if (data != null) {
          this.generatedShowMessage = true
          setTimeout(() => {
            this.generatedShowMessage = false
          }, 5000)
          this.getDocumentsList(this.retrieved.id)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UpdateDocuments.vue?2ff579e6